<template>
  <div id="custom__table">
    <TableWithFilter
      id="departmentOrderTable"
      @update:sort="getOrdersWithLoading"
      isEnabledResizeTable
      is-enabled-orderable-table
      @change-header-order="onChangeHeaderOrder"
      fixed-header
      @table-header-resized="onChangeSizeHeader"
      :headers="filterableHeadersTable"
      :items="orders"
      :options.sync="tableOptions"
      child-key="items"
      handler-value="numb"
      item-key="id"
      @onException="(e) => setResponseError({ error: e })"
      :page="tableOptions.page"
    >
      <template #item.department="{ item }">
        <span>{{ item[`department_${$i18n.locale}`] }}</span>
      </template>
      <template #header.rejectionReason="{ header }">
        <span class="d-inline-block w-110">{{ header.text }}</span>
      </template>
      <template #item.action="{ item, index }">
        <v-btn
          v-if="$store.getters.isUserAdmin"
          @click="$emit('openOrderHistoryDialog', item.id)"
          class="new_style"
          :title="$tc('orderHistory', 1)"
          :data-test="`divisionOrders-order-${index}-reindex-btn`"
        >
          <vue-icon icon="newTimeIcon"></vue-icon>
        </v-btn>
        <v-tooltip color="#fff" left nudge-right="10" nudge-top="35">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="new_style"
              @click="$emit('openOrderDialog', { item })"
              :data-test="`divisionOrders-order-${index}-edit-btn`"
            >
              <vue-icon icon="newPencilIcon"></vue-icon>
            </v-btn>
          </template>
          <span>{{ $t("edit") }}</span>
        </v-tooltip>
        <v-tooltip
          v-if="
            !item.sendDate &&
            $can($permissions['DEPARTMENT.CREATE.REQUEST']) &&
            item.owner
          "
          color="#fff"
          left
          nudge-right="10"
          nudge-top="35"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="new_style"
              @click="$emit('addProduct', item, true)"
              :data-test="`divisionOrders-order-${index}-addProduct-btn`"
            >
              <vue-icon icon="newPlusIcon"></vue-icon>
            </v-btn>
          </template>
          <span>{{ $t("addProduct") }}</span>
        </v-tooltip>
        <v-btn
          class="new_style"
          @click="$emit('openOrderDialogView', { item })"
          :data-test="`divisionOrders-order-${index}-eye-btn`"
        >
          <vue-icon icon="newEyeIcon"></vue-icon>
        </v-btn>
        <!--     toDO fix it   v-if="-->
        <!--        !item.sendDate &&-->
        <!--        $can($permissions['DEPARTMENT.SEND.REQUEST']) &&-->
        <!--        item.owner-->
        <!--        "-->
        <v-tooltip
          v-if="$store.getters.isUserAdmin"
          color="#fff"
          left
          nudge-right="10"
          nudge-top="35"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="new_style"
              @click="$refs.deleteOrderConfirmDialogRef.open(item)"
              :data-test="`divisionOrders-order-${index}-delete-btn`"
            >
              <vue-icon icon="newTrashIcon"></vue-icon>
            </v-btn>
          </template>
          <span>{{ $t("delete") }}</span>
        </v-tooltip>

        <v-tooltip
          v-if="!item.sendDate && item.owner"
          color="#fff"
          left
          nudge-right="10"
          nudge-top="35"
        >
          <template v-slot:activator="{ on, attrs }">
            <!--If you add to 'btn_33' element 'disabled' class. it is disabled element  -->
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="new_style"
              @click="sendOrder(item)"
              :data-test="`divisionOrders-order-${index}-send-btn`"
            >
              <vue-icon icon="newRightArrow"></vue-icon>
            </v-btn>
          </template>
          <span>{{ $t("send") }}</span>
        </v-tooltip>
        <downloader
          v-if="item['attachmentLink']"
          :address="item['attachmentLink']"
          :file-name="item.attachmentFileName"
        >
        </downloader>
      </template>
      <template #item.state="{ item }">
        <span
          :style="{ color: item.statusColour }"
          class="font-weight-bold no-wrap-text"
          >{{ $t(item.statusCode) }}</span
        >
      </template>
      <template #item.sendDate="{ item }">
        {{ item.sendDate | fullTimeParse }}
      </template>
      <template #item.timeToBeEntered="{ item: { timeToBeEntered } }"
        >{{ timeToBeEntered | fullTimeParse }}
      </template>
      <template #child.timeToBeEntered="{ child: { timeToBeEntered } }"
        >{{ timeToBeEntered | fullTimeParse }}
      </template>
      <template #child.productTypeName="{ child }"
        >{{ child[`product_type_${$i18n.locale}`] }}
      </template>
      <template #child.pendingPurchaseDate="{ child: { pendingPurchaseDate } }"
        >{{ pendingPurchaseDate | fullTimeParse }}
      </template>
      <template #child.contractDate="{ child: { contractDate } }"
        >{{ contractDate | fullTimeParse }}
      </template>
      <template #child.itemConclusionDate="{ child: { itemConclusionDate } }"
        >{{ itemConclusionDate | fullTimeParse }}
      </template>
      <template #item.receiverDate><span></span></template>
      <template #child.receiverDate="{ child }"
        >{{ child.actualReceiveDate | fullTimeParse }}
      </template>
      <template #child.count="{ child }">
        <span class="no-wrap-text">
          {{ child.given }} /
          {{ child.count }}
        </span>
      </template>
      <template #child.action="{ item, itemIndex, child, index }">
        <div class="d-flex">
          <v-tooltip
            v-if="child.state === orderStatus.NEW && item.owner"
            color="#fff"
            left
            nudge-right="10"
            nudge-top="35"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="new_style"
                @click="$emit('editDepartmentOrderForm', item, child)"
                :data-test="`divisionOrders-order-${itemIndex}-orderItem-${index}-edit-btn`"
              >
                <vue-icon icon="newPencilIcon"></vue-icon>
              </v-btn>
            </template>
            <span>{{ $t("edit") }}</span>
          </v-tooltip>
          <v-tooltip
            v-if="
              child.state === orderStatus.NEW &&
              $can($permissions['DEPARTMENT.DELETE.REQUEST']) &&
              item.owner
            "
            color="#fff"
            left
            nudge-right="10"
            nudge-top="35"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="new_style"
                @click="$emit('deleteChildItem', child)"
                :data-test="`divisionOrders-order-${itemIndex}-orderItem-${index}-delete-btn`"
              >
                <vue-icon icon="newTrashIcon"></vue-icon>
              </v-btn>
            </template>
            <span>{{ $t("delete") }}</span>
          </v-tooltip>
          <v-tooltip
            v-if="
              hasRemainCount(child.count, child.given) &&
              item.owner &&
              child.state === orderItemStatus.YES_PRODUCT
            "
            color="#fff"
            left
            nudge-right="10"
            nudge-top="35"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="new_style"
                @click="
                  $emit('sendNotificationToOMTK', {
                    id: child.id,
                    maxCount: parseFloat(child.count) - parseFloat(child.given),
                    productName: child.productName,
                  })
                "
                :data-test="`divisionOrders-order-${itemIndex}-orderItem-${index}-send-btn`"
              >
                <vue-icon icon="bellIcon" />
              </v-btn>
            </template>
            <span>{{ $t("sendNotificationToOMTK") }}</span>
          </v-tooltip>
          <v-tooltip
            v-if="
              child.state === orderItemStatus.OZL_TO_DEPARTMENT && item.owner
            "
            color="#fff"
            left
            nudge-right="10"
            nudge-top="35"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="new_style"
                @click="$emit('openChangeRequestOrderItemDialog', child)"
                :data-test="`divisionOrders-order-${itemIndex}-orderItem-${index}-share-btn`"
              >
                <vue-icon icon="newShareIcon"></vue-icon>
              </v-btn>
            </template>
            <span>{{ $t("send") }}</span>
          </v-tooltip>
          <v-tooltip
            v-if="$can($permissions['ORDER_CHANGE_STATE'])"
            color="#fff"
            left
            nudge-right="10"
            nudge-top="35"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="new_style"
                @click="
                  $emit('editDivisionOrderItem', {
                    numb: item.numb,
                    itemNumb: child.itemNumb,
                    id: child.id,
                    state: child.state,
                  })
                "
                :data-test="`divisionOrders-order-${itemIndex}-orderItem-${index}-settings-btn`"
              >
                <vue-icon icon="newCogIcon"></vue-icon>
              </v-btn>
            </template>
            <span>{{ $t("edit") }}</span>
          </v-tooltip>
        </div>
      </template>
      <template #child.hasProductCount="{ child }">
        {{ Number(child.hasProductCount) }}
      </template>
      <template #child.contractNumber="{ child }">
        {{ child.contractNumber }}
        <!--        <downloader-->
        <!--          v-if="child['contractLink']"-->
        <!--          :address="child['contractLink']"-->
        <!--          :file-name="child.contractFileName"-->
        <!--        >-->
        <!--          <template #default="{ downloadFile }">-->
        <!--            <a-->
        <!--              class="text-decoration-underline"-->
        <!--              @click.prevent="downloadFile"-->
        <!--              >{{ child.contractNumber }}</a-->
        <!--            >-->
        <!--          </template>-->
        <!--        </downloader>-->
        <VIcon
          class="ml-2 cursor-pointer"
          v-if="child['contractLink']"
          @click="pushContractNumberToRouter(child.contractNumber)"
          >mdi-link</VIcon
        >
      </template>
      <template #child.acts="{ child: { id, contractNumber } }">
        <v-btn
          v-if="contractNumber"
          class="new_style"
          @click="$emit('openOrderItemActFilesDialog', id)"
        >
          <vue-icon icon="newFileEdit" />
        </v-btn>
      </template>
      <template #child.state="{ child }">
        <v-tooltip
          v-if="
            (child.state === orderItemStatus.READY_TO_PRODUCE ||
              child.state === orderItemStatus.YES_PRODUCT) &&
            child.warehouses &&
            child.warehouses.length
          "
          color="#fff"
          content-class="description_tooltip"
          left
          nudge-right="40"
          nudge-top="50"
        >
          <template #activator="{ on }">
            <p
              v-on="on"
              :style="{ cursor: 'help', color: child.statusColour }"
              class="mb-0 d-flex align-center no-wrap-text font-weight-bold"
            >
              {{ $t(child.state) }}
              <vue-icon
                :color="child.statusColour || '#01456A'"
                class="ml-2 d-inline-block"
                icon="infoIcon"
              ></vue-icon>
            </p>
          </template>
          {{
            $t(`orderItemStatusDescription.${orderItemStatus.YES_PRODUCT}`, {
              name: child.warehouses.join(", "),
            })
          }}
        </v-tooltip>
        <v-tooltip
          v-else-if="child.state === 'PAPER_EXPECTED_SPECIFICATION'"
          color="#fff"
          content-class="description_tooltip"
          left
          nudge-right="40"
          nudge-top="50"
        >
          <template #activator="{ on }">
            <p
              v-on="on"
              :style="{ cursor: 'help', color: child.statusColour }"
              class="mb-0 d-flex align-center no-wrap-text font-weight-bold"
            >
              {{ $t(child.state) }}
              <vue-icon
                :color="child.statusColour || '#01456A'"
                class="ml-2 d-inline-block"
                icon="infoIcon"
              ></vue-icon>
            </p>
          </template>
          {{ $t(`orderItemStatusDescription.${child.state}`) }}
        </v-tooltip>
        <span
          v-else
          :style="{ color: child.statusColour }"
          class="font-weight-bold no-wrap-text"
          >{{ $t(child.state) }}</span
        >
      </template>
      <template #expandBtn="{ item, openHandler }">
        <triangle-btn
          :active="item.show"
          :loading="item.loading"
          @click="
            () => {
              openHandler(item);
              $toggleShowHandler(item.id, item.show);
            }
          "
        ></triangle-btn>
      </template>
      <template
        #child.rejectionReason="{
          /**
           * @type Object
           * @property rejectionFileLink {string}
           * @property rejectionFileName {string}
           */
          child,
        }"
      >
        <downloader
          v-if="child.rejectedSource"
          :address="child?.rejectedSource"
          :file-name="child?.rejectionFileName"
        >
          <template #default="{ downloadFile }">
            <a
              class="text-decoration-underline"
              @click.prevent="downloadFile"
              >{{ child.rejectionReason }}</a
            >
          </template>
        </downloader>
      </template>
      <template #child.numb><span></span></template>
      <template #child.numberRequestOrderItem="{ child }">
        {{ child.numb }}
      </template>
      <template #child.guessReceiveDate="{ child }">
        {{ child.itemGuessReceiveDate | dateParse }}
      </template>
      <template #child.productAttrs="{ child }">
        <span v-if="child.productDescription">{{
          child.productDescription
        }}</span>
      </template>
      <template #child.unitTypeName="{ child }">
        {{ child[`unit_type_name_${$i18n.locale}`] }}
      </template>
      <template #append:child="{ item }">
        <tr v-if="item.itemsPageCount > 1">
          <td :colspan="filterableHeadersTable.length">
            <div class="d-flex">
              <vue-pagination
                @input="
                  (page) => {
                    onChangeItemPage({ page, item });
                  }
                "
                :length="item.itemsPageCount"
                v-model="item.itemsCurrentPage"
              ></vue-pagination>
            </div>
          </td>
        </tr>
      </template>
    </TableWithFilter>
    <warning-dialog
      v-model="warningDialog"
      @apply="deleteOrderHandler"
      ref="deleteOrderConfirmDialogRef"
    ></warning-dialog>
  </div>
</template>

<script>
// import VueSelect from "@/components/ui/vue-select/VueSelect";
import TableWithFilter from "@/components/ui/table/TableWithFilter";
import Downloader from "@/components/ui/downloader";
import TriangleBtn from "@/components/table-with-children/triangleBtn";
import gridTableMixin from "@/configuration/mixins/gridTableMixin.js";
import { TABLES, orderStatus, orderItemStatus } from "@/utils/constants.js";
import VuePagination from "@/components/ui/vue-pagination/VuePagination";
import WarningDialog from "@/components/ui/prompt/warning-dialog";

const ITEM_LIMIT = 200;

export default {
  name: "department-order-table",
  data() {
    return {
      warningDialog: false,
    };
  },
  props: {
    productGroups: {
      type: Array,
    },
    setProductGroup: {
      type: Function,
    },
    setProductType: {
      type: Function,
    },
    orders: {
      type: Array,
    },
    filterableHeadersTable: {
      type: Array,
    },
    tableOptions: {
      type: Object,
    },
    getOrdersWithLoading: {
      type: Function,
    },
    onChangeFilter: {
      type: Function,
    },
    orderListFilter: {
      type: Object,
    },
    productTypes: {
      type: Array,
    },
  },
  components: {
    TableWithFilter,
    Downloader,
    TriangleBtn,
    VuePagination,
    WarningDialog,
  },
  computed: {
    orderStatus: () => orderStatus,
    orderItemStatus: () => orderItemStatus,
    orderItemStatusList() {
      return Object.keys(orderItemStatus).map((item) => {
        return {
          name: this.$t(item),
          id: item,
        };
      });
    },
  },
  methods: {
    pushContractNumberToRouter(contractNum) {
      this.$router.push({
        path: `division-contracts?code=${contractNum}`,
        query: { showContract: "true" },
      });
    },
    async deleteOrderHandler(item) {
      try {
        this.showLoading();
        await this.$http.delete("office/orders/delete", {
          params: { id: item.id },
        });
        this.$emit("deleted");
        await this.getOrdersWithLoading();
      } catch (err) {
        this.setResponseError({ error: err });
      } finally {
        this.clearLoading();
      }
    },
    async sendOrder(item) {
      this.showLoading();
      try {
        const {
          data: {
            data: { items, sendDate, state },
          },
        } = await this.$http.post(`office/orders/send/${item.id}`, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        item.sendDate = sendDate;
        item.state = state;
        item.statusCode = state;
        if (item.show) {
          item.items = item.items.map((child, index) => {
            child.state = items[index].state;
            child.statusColour = items[index].statusColour;
            return child;
          });
        }
        this.setSuccess({
          text: this.$t("orderSent"),
        });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    hasRemainCount(allCount, givenCount) {
      if (allCount && givenCount) {
        return parseFloat(allCount) - parseFloat(givenCount) > 0;
      }
      return false;
    },
    async onChangeItemPage(params) {
      this.showLoading();
      try {
        const page = params.page - 1;
        const {
          data: { data },
        } = await this.$http.get("orders/items-department", {
          params: {
            limit: ITEM_LIMIT,
            page,
            objectId: params.item.id,
            ...this.orderListFilter,
          },
        });
        params.item.items = data;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
  },
  mixins: [gridTableMixin(TABLES.Order.slug)],
};
</script>

<style lang="scss">
#custom__table {
  .header_name_filter_table {
    background-color: #ffffff;
    border-bottom: 1px solid #dde6ef !important;
  }
  .header_filter_table {
    display: none;
  }
  .table_cover tbody tr td {
    border-bottom: 1px solid #dde6ef !important;
    border-top: 1px solid #dde6ef !important;
    border-right: 1px solid #dde6ef !important;
    border: none;
  }
}
</style>
